import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["", ""]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["", ""]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["", ""]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["", ""]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { spreadByBreakpoints } from './media-spread';
import { sizes } from '../breakpoints';
import media from '../media';
import { isDefined } from './defined';
export var styleForBreakpoints = function styleForBreakpoints(props, getStyleFn, needSpreadProps) {
  if (needSpreadProps === void 0) {
    needSpreadProps = true;
  }

  if (needSpreadProps) {
    var spreadProps = spreadByBreakpoints(props, true);
    return sizes.map(function (size) {
      return media.only[size](_templateObject(), getStyleFn(spreadProps[size], size));
    });
  } else {
    return sizes.map(function (size) {
      return media.only[size](_templateObject2(), getStyleFn(props[size], size));
    });
  }
};
export var styleArrayForBreakpoints = function styleArrayForBreakpoints(props, getStyleFn, needSpreadProps) {
  if (needSpreadProps === void 0) {
    needSpreadProps = true;
  }

  if (needSpreadProps) {
    var spreadProps = props.map(function (value) {
      return spreadByBreakpoints(value, true);
    });
    return sizes.map(function (breakpoint) {
      return media.only[breakpoint](_templateObject3(), getStyleFn(spreadProps.map(function (value) {
        return value[breakpoint];
      }), breakpoint));
    });
  } else {
    return sizes.map(function (breakpoint) {
      return media.only[breakpoint](_templateObject4(), getStyleFn(props.map(function (value) {
        return value[breakpoint];
      }), breakpoint));
    });
  }
};
export var styleFlagForBreakpoints = function styleFlagForBreakpoints(flag, style, needSpreadProps) {
  if (needSpreadProps === void 0) {
    needSpreadProps = true;
  }

  if (!isDefined(flag)) {
    return '';
  }

  if (typeof flag === 'boolean') {
    return flag ? style : '';
  }

  return styleForBreakpoints(flag, function (flag) {
    return flag ? style : '';
  }, needSpreadProps);
};